export enum Months {

  JANUARY,
  FEBRUARY,
  MARCH,
  APRIL,
  MAY,
  JUNE,
  JULY,
  AUGUST,
  SEPTEMBER,
  OCTOBER,
  NOVEMBER,
  DECEMBER

}

export namespace Months {

  export function fromString(name: string): Months {
    return Months[name];
  }

  const MEANINGS = new Map<number, string>([
    [Months.JANUARY, 'January'],
    [Months.FEBRUARY, 'February'],
    [Months.MARCH, 'March'],
    [Months.APRIL, 'April'],
    [Months.MAY, 'May'],
    [Months.JUNE, 'June'],
    [Months.JULY, 'July'],
    [Months.AUGUST, 'August'],
    [Months.SEPTEMBER, 'September'],
    [Months.OCTOBER, 'October'],
    [Months.NOVEMBER, 'November'],
    [Months.DECEMBER, 'December']
  ]);

  export function meaning(type: Months) {
    return MEANINGS.get(type);
  }

  export function values(): Months[] {
    return Array.from(MEANINGS.keys());
  }

}
